module.exports = __webpack_public_path__ + "img/main.a6d65a28.svg";